import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../../../utils/webpack/chunkRetry';
import NotesModuleLoader from '../../../../Notes/redux/drawer/ModuleLoaderLazy';
import { type Props } from './DesktopNotesPanel';

const DesktopNotesPanel = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "notes_desktop_panel" */
        './index'
      )
  )
);

const LoadableDesktopNotesPanel: React.FC<Props> = props => {
  return (
    <ErrorBoundary debugComponent="LoadableDesktopNotesPanel">
      <Suspense fallback={null}>
        <NotesModuleLoader />
        <DesktopNotesPanel {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
LoadableDesktopNotesPanel.displayName = 'LoadableDesktopNotesPanel';

export default LoadableDesktopNotesPanel;
